import { awaitLoad } from '../page-modules/page-modules';
import { asyncAddExtenalScript } from '../utility-functions/async-external-assets';
import { showSolidHeader, showGlassHeader } from '../../global';
import { disableScroll, enableScroll } from '../utility-functions/utility-functions';
import { isTouch } from '@remarkablenet/rcm-utils';

const shouldLockScrollOnPanel = (id: string) => !isTouch() || id !== 'Product Zoom';

export const isPanelOpen = (id: string): boolean =>
  document.querySelector(`.slideout-module[data-id="${id}"]`)?.classList.contains('active') ?? false;

export const slideoutPanel = () => {
  const panels = document.querySelectorAll('.slideout-module') as NodeListOf<HTMLElement>;
  const overlays = document.querySelectorAll('.slideout-module__overlay') as NodeListOf<HTMLElement>;

  panels.forEach((panel) => {
    const id = panel.dataset.id;
    panel.querySelector('.slideout-module__close')?.addEventListener('click', () => {
      closePanel(id);
    });
  });

  overlays.forEach((overlay) => {
    const id = overlay.dataset.id;
    overlay.addEventListener('click', () => {
      closePanel(id);
    });
  });
};

export const closePanel = (id: string) => {
    const panel = document.querySelector(`.slideout-module[data-id="${id}"]`);
    const wasOpen = panel?.classList.contains('active') ?? false;

    document.dispatchEvent(new CustomEvent('slideout-panel-close', { detail: { id: id } }));

    panel?.classList.remove('active');
    document.querySelector(`.slideout-module__overlay[data-id="${id}"]`)?.classList.remove('active');

    if (!document.querySelector('.slideout-module.active')) {
        document.documentElement.classList.remove('slideout-module-active');
    }

    if (wasOpen && shouldLockScrollOnPanel(id)) {
        enableScroll();
    }

    showGlassHeader(500);
};

export const openPanel = (id: string, callback?) => {
    const panel = document.querySelector(`.slideout-module[data-id="${id}"]`);
    const wasOpen = panel?.classList.contains('active') ?? false;

    document.dispatchEvent(new CustomEvent('slideout-panel-open', { detail: { id: id } }));

    if (!wasOpen && shouldLockScrollOnPanel(id)) {
        disableScroll();
    }

    panel?.classList.add('active');
    document.querySelector(`.slideout-module__overlay[data-id="${id}"]`)?.classList.add('active');
    document.documentElement.classList.add('slideout-module-active');
    if (!isTouch()) showSolidHeader();

    return callback;
};

export const updatePanel = async (id: string, html, title?: string) => {
  const panel = document.querySelector(`.slideout-module[data-id="${id}"] .slideout-module__body`) as HTMLElement;
  const panelHeader = document.querySelector(
    `.slideout-module[data-id="${id}"] .slideout-module__header h3`
  ) as HTMLElement;

  if (panel) {
    panel.innerHTML = html;

    if (title != null) {
      panelHeader.innerHTML = title;
    }
    panel.dataset.state = 'loaded';

    const script = panel.querySelector('.pageJS');
    const codemodule = script ? script.getAttribute('module') : null;
    if (codemodule) {
      script.remove();
      asyncAddExtenalScript(script.getAttribute('src') as string, {
        module: codemodule,
        id: id,
        async: true,
        defer: true,
        class: 'pageJS'
      });

      try {
        await awaitLoad(codemodule, "script.pageJS[module='" + codemodule + "']").then(function (result) {
          window[codemodule].init.bind(window)();
          document.addEventListener(
            'slideout-panel-close',
            function (e: CustomEvent) {
              if (e.detail.id == id) {
                window[codemodule].exit.bind(window)();
                document.querySelectorAll("script[module='" + codemodule + "']").forEach((script) => script.remove());
              }
            },
            { once: true }
          );
        });
      } catch (error) {
        console.log(error);
      }
    }
  } else {
    throw new Error(`Panel "${id}" does not exist`);
  }

  const close = document.querySelector(`.slideout-module[data-id="${id}"] [data-close]`);

  if (close) {
    close.addEventListener('click', () => {
      closePanel(id);
    });
  }
};
